import React from "react";
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import TextField from '@mui/material/TextField';

export const DatePicker = props => <LocalizationProvider dateAdapter={AdapterMoment}>
  <MobileDatePicker
    label={props.label}
    inputFormat="YYYY/MM/DD"
    value={props.value}
    onChange={props.onChange}
    {...props}
    renderInput={(params) => <TextField {...params} />}
  />
</LocalizationProvider>
